import React from 'react';
import { node, object, number, oneOf } from 'prop-types';
import { getContext } from '@fiverr-private/fiverr_context';
import { getLocalizationContext } from '@fiverr-private/localization';
import { Popover } from '@fiverr-private/fit';
import { MP_CLICKED_ON_PAYMENT_DETAILS } from '../../../utils/mixPanelEvents';
import { BQ_CLICKED_ON_PAYMENT_DETAILS } from '../../../utils/bigQueryEvents';
import PriceSummaryContent from './Content';

import './style.scss';

const PriceSummaryPopover = ({ packageId, sourceComponent, children }, { biEvents }) => {
    const reportPopoverOpened = () => {
        const { locale, currency } = getContext();
        const { formattingLocale } = getLocalizationContext();

        biEvents.sendMixPanelEvent({
            eventName: MP_CLICKED_ON_PAYMENT_DETAILS,
            params: {
                'Page name': 'Gig page',
                'Source component': sourceComponent
            }
        });
        biEvents.sendBigQueryEvent({
            eventName: BQ_CLICKED_ON_PAYMENT_DETAILS,
            params: {
                event_source: sourceComponent,
                locale,
                currency,
                formattingLocale
            }
        });
    };

    return (
        <Popover content={<PriceSummaryContent packageId={packageId}/>}
            className="price-summary-popover"
            onOpen={reportPopoverOpened}
            position={Popover.POSITIONS.BOTTOM_RIGHT}
            appendToBody={false}>
            {children}
        </Popover>
    );
};

export const SOURCE_COMPONENT = {
    STICKY_SUMMARY: 'Sticky summary',
    PACKAGES: 'packages'
};

PriceSummaryPopover.contextTypes = {
    biEvents: object
};

PriceSummaryPopover.propTypes = {
    packageId: number.isRequired,
    sourceComponent: oneOf(Object.values(SOURCE_COMPONENT)).isRequired,
    children: node.isRequired
};

export default PriceSummaryPopover;
